import { FormHelperText as ChakraFormHelperText } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { getFontFromVariant } from '../../_helpers/index';
import { InferPropTypes } from '../../types';

const propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  fontSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  fontWeight: PropTypes.oneOf(['normal', 'medium', 'semibold']),
  variant: PropTypes.oneOf(['base', 'code'])
};

const defaultProps = {
  color: 'grey.light',
  fontSize: 'md',
  fontWeight: 'normal',
  variant: 'base'
};

export type FormHelperTextProps = InferPropTypes<typeof propTypes, typeof defaultProps>;
export default function FormHelperText(props: FormHelperTextProps): React.ReactElement {
  const { children, fontSize, fontWeight, variant, ...rest } = props;

  const overrides = {
    fontSize,
    fontWeight,
    fontFamily: getFontFromVariant(variant, fontWeight)
  };

  return (
    <ChakraFormHelperText {...overrides} {...rest}>
      {children}
    </ChakraFormHelperText>
  );
}

FormHelperText.propTypes = propTypes;
FormHelperText.defaultProps = defaultProps;
